module.exports = __webpack_public_path__ + "static/media/download-white.c397aa44.png";